// lavo-image-slider用
document.addEventListener('DOMContentLoaded', function () {

  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.image-slider-swiper').forEach(function(slider){

    const slideCount = slider.querySelectorAll('.swiper-slide').length;

    new Swiper(slider, {
      loop: slideCount > 1,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      autoplay: slideCount > 1 ? {
        delay: 5000,
        disableOnInteraction: false
      } : false,
      navigation: false,
      pagination: false
    });

  });

});